import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class MonthlyRetainedServiceBase {

//#region monthlyRetainedServiceId Prop
        @prop()
        monthlyRetainedServiceId : number;
//#endregion monthlyRetainedServiceId Prop


//#region monthlyRetainedOptionId Prop
        @range({minimumNumber:1,maximumNumber:2147483647})
        @required()
        monthlyRetainedOptionId : number;
//#endregion monthlyRetainedOptionId Prop


//#region monthlyRetainedServiceName Prop
        @required()
        @maxLength({value:100})
        monthlyRetainedServiceName : string;
//#endregion monthlyRetainedServiceName Prop


//#region monthlyRetainedServiceTypeId Prop
        @range({minimumNumber:1,maximumNumber:2147483647})
        @required()
        monthlyRetainedServiceTypeId : number;
//#endregion monthlyRetainedServiceTypeId Prop


//#region isRequired Prop
        @required()
        isRequired : boolean;
//#endregion isRequired Prop


//#region statusId Prop
        @range({minimumNumber:1,maximumNumber:2147483647})
        @required()
        statusId : number;
//#endregion statusId Prop


//#region createdBy Prop
        @range({minimumNumber:1,maximumNumber:2147483647})
        @required()
        createdBy : number;
//#endregion createdBy Prop


//#region createdOn Prop
        @required()
        createdOn : any;
//#endregion createdOn Prop


//#region modifiedBy Prop
        @prop()
        modifiedBy : number;
//#endregion modifiedBy Prop


//#region modifiedOn Prop
        @prop()
        modifiedOn : any;
//#endregion modifiedOn Prop





}